module.exports = "td{\n    margin: 0;\n}\n.selected{\n    font-weight: bold;\n}"